import React, { useEffect, useState } from "react";
import "./Contract.scss";
import AppButton from "../../../../../components/ui/components/Buttons/AppButton/AppButton";
import hotelRegistrationApi from "../../../../../api/hotel-registration-api";


const Contract = ({ onCloseContractStep }) => {
  const [rules, setRules] = useState<string>('');

  useEffect(() => {
    hotelRegistrationApi.fetchRules().then((res) => {
      console.log("data",res.data.rules);


      setRules(res.data.rules);
    }).catch((error) => {

    }).finally(() => {

    })
  }, [])

  return (
    <div className="registration-hotel-contract">
      <div dangerouslySetInnerHTML={{__html: rules}}></div>

      <AppButton onClick={onCloseContractStep} theme="primary"
                 className="registration-hotel-contract__button">Погоджуюсь</AppButton>
    </div>
  )
}

export default Contract;